import { j as n } from "./atoms-v218.js";
import { forwardRef as j } from "react";
import { ButtonSkeleton as B } from "./atoms-v299.js";
import { useGetChildrenTypes as g } from "./atoms-v2100.js";
import { Button as T, Content as C } from "./atoms-v2101.js";
const I = j(
  ({
    ariaLabel: o = "",
    children: e,
    className: u,
    colorTheme: s = "light",
    disabled: a = !1,
    display: f = "inline",
    iconOnly: c = !1,
    id: y,
    isSkeleton: i = !1,
    onClick: x,
    shape: $ = "pill",
    size: l = "medium",
    textOnly: d = !1,
    type: h = "button",
    variant: r = "primary"
  }, O) => {
    const t = g(e), m = t.length === 1 && t.includes("icon") || c, p = t.length === 1 && t.includes("string") || d;
    return i ? /* @__PURE__ */ n.jsx(
      B,
      {
        ariaLabel: o,
        colorTheme: s,
        iconOnly: m,
        size: l,
        textOnly: p,
        variant: r
      }
    ) : /* @__PURE__ */ n.jsx(
      T,
      {
        $colorTheme: s,
        $display: f,
        $isIconOnly: m,
        $isSkeleton: i,
        $isTextOnly: p,
        $shape: $,
        $size: l,
        $variant: r,
        "aria-label": o,
        className: u,
        disabled: a,
        id: y,
        onClick: x,
        ref: O,
        type: h,
        children: /* @__PURE__ */ n.jsx(C, { children: e })
      }
    );
  }
);
I.displayName = "Button";
export {
  I as Button
};
